import React from "react";
import { X } from "lucide-react";
import BlogAIAssistant from "./BlogAIAssistant";

interface BlogAIModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContentSelect: (content: string) => void;
  onTitleSelect: (title: string) => void;
  onMetaSelect: (meta: string) => void;
}

export default function BlogAIModal({
  isOpen,
  onClose,
  onContentSelect,
  onTitleSelect,
  onMetaSelect,
}: BlogAIModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-900">
            AI Blog Assistant
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <BlogAIAssistant
            onContentSelect={(content) => {
              onContentSelect(content);
              onClose();
            }}
            onTitleSelect={(title) => {
              onTitleSelect(title);
              onClose();
            }}
            onMetaSelect={(meta) => {
              onMetaSelect(meta);
              onClose();
            }}
          />
        </div>
      </div>
    </div>
  );
}
